
define('text!presentation/marketing/views/index.html',[],function () { return '<div></div>\n';});

